import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-[95%] max-w-[1600px] h-[90vh] flex flex-col overflow-hidden" }
const _hoisted_2 = { class: "flex items-center justify-between px-6 py-4 bg-gray-100 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_3 = { class: "flex-1 overflow-hidden flex" }
const _hoisted_4 = { class: "flex-1 flex flex-col border-r border-gray-200 dark:border-gray-700 overflow-hidden" }
const _hoisted_5 = { class: "flex-1 overflow-auto font-mono text-xs" }
const _hoisted_6 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_7 = { class: "flex-1 overflow-auto font-mono text-xs" }

import { computed, onMounted, onUnmounted } from 'vue'
import { taskSentinelService } from '../../../services/task-sentinel'
import type { Team, DiffLine } from '../../../types/task-sentinel'


export default /*@__PURE__*/_defineComponent({
  __name: 'DiffModal',
  props: {
    oldData: {},
    newData: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Computed diff
const diffLines = computed<DiffLine[]>(() => {
  const sortedOld = props.oldData ? taskSentinelService.sortJsonKeys(props.oldData) : null
  const sortedNew = props.newData ? taskSentinelService.sortJsonKeys(props.newData) : null

  const oldText = sortedOld ? JSON.stringify(sortedOld, null, 2) : ''
  const newText = sortedNew ? JSON.stringify(sortedNew, null, 2) : ''

  const oldLines = oldText.split('\n')
  const newLines = newText.split('\n')

  return taskSentinelService.computeLineDiff(oldLines, newLines)
})

// Handle escape key
const handleKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    emit('close')
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleKeydown)
  // Prevent body scroll when modal is open
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeydown)
  document.body.style.overflow = ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-5",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"])),
    onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('close')), ["escape"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900 dark:text-white" }, " Validation Results - JSON Diff ", -1)),
        _createElementVNode("button", {
          class: "px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md text-sm font-medium transition-colors",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, " ✕ Close ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "px-4 py-3 bg-red-50 dark:bg-red-900/30 border-b border-gray-200 dark:border-gray-700 font-semibold text-red-700 dark:text-red-300 sticky top-0" }, " Old ", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diffLines.value, (line, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `old-${index}`,
                class: _normalizeClass([
                'flex border-t border-gray-100 dark:border-gray-700',
                line.type === 'delete' ? 'bg-red-50 dark:bg-red-900/20' : '',
                line.type === 'add' ? 'bg-gray-50 dark:bg-gray-800' : ''
              ])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([
                  'px-3 py-0.5 text-right min-w-[50px] select-none border-r border-gray-200 dark:border-gray-700',
                  line.type === 'delete'
                    ? 'bg-red-100 dark:bg-red-900/40 text-red-500'
                    : 'bg-gray-50 dark:bg-gray-900 text-gray-400'
                ])
                }, _toDisplayString(line.type !== 'add' ? line.oldNum : ''), 3),
                _createElementVNode("pre", {
                  class: _normalizeClass([
                  'flex-1 px-3 py-0.5 whitespace-pre overflow-x-auto',
                  line.type === 'delete'
                    ? 'text-red-800 dark:text-red-200'
                    : 'text-gray-700 dark:text-gray-300'
                ])
                }, _toDisplayString(line.type !== 'add' ? line.oldLine : ''), 3)
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "px-4 py-3 bg-green-50 dark:bg-green-900/30 border-b border-gray-200 dark:border-gray-700 font-semibold text-green-700 dark:text-green-300 sticky top-0" }, " New ", -1)),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diffLines.value, (line, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `new-${index}`,
                class: _normalizeClass([
                'flex border-t border-gray-100 dark:border-gray-700',
                line.type === 'add' ? 'bg-green-50 dark:bg-green-900/20' : '',
                line.type === 'delete' ? 'bg-gray-50 dark:bg-gray-800' : ''
              ])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([
                  'px-3 py-0.5 text-right min-w-[50px] select-none border-r border-gray-200 dark:border-gray-700',
                  line.type === 'add'
                    ? 'bg-green-100 dark:bg-green-900/40 text-green-500'
                    : 'bg-gray-50 dark:bg-gray-900 text-gray-400'
                ])
                }, _toDisplayString(line.type !== 'delete' ? line.newNum : ''), 3),
                _createElementVNode("pre", {
                  class: _normalizeClass([
                  'flex-1 px-3 py-0.5 whitespace-pre overflow-x-auto',
                  line.type === 'add'
                    ? 'text-green-800 dark:text-green-200'
                    : 'text-gray-700 dark:text-gray-300'
                ])
                }, _toDisplayString(line.type !== 'delete' ? line.newLine : ''), 3)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ], 32))
}
}

})